<script setup lang="ts">
const { title } = defineProps<{
  title?: string
}>()
</script>

<template>
  <BaseCard class="flex flex-col gap-y-4 p-4">
    <slot name="title">
      <BaseHeading
        v-if="title"
        as="h2"
        class="text-muted-700 dark:text-muted-400"
      >
        {{ title }}
      </BaseHeading>
    </slot>

    <slot />
  </BaseCard>
</template>
